module.exports = __webpack_public_path__ + "static/media/nature.3503d932.svg";